import * as __WEBPACK_EXTERNAL_MODULE__designTokens_gen_js_7b1faa8e__ from "../designTokens.gen.js";
const theme = new Proxy({
    ...__WEBPACK_EXTERNAL_MODULE__designTokens_gen_js_7b1faa8e__
}, {
    get: (_, prop)=>{
        const themeOverride = {
            ...__WEBPACK_EXTERNAL_MODULE__designTokens_gen_js_7b1faa8e__
        };
        return themeOverride[prop];
    },
    ownKeys (target) {
        return Reflect.ownKeys(target);
    }
});
export { theme };
